import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-password-expired-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './password-expired-modal.html',
  styleUrls: ['./password-expired-modal.scss']
})
export class PasswordExpiredModalComponent {
  @Input() isVisible = false;
  @Input() daysRemaining = 0;
  @Output() changePassword = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();

  get isExpired(): boolean {
    return this.daysRemaining <= 0;
  }

  get title(): string {
    return this.isExpired
      ? 'Tu contraseña ha expirado'
      : 'Tu contraseña está por expirar';
  }

  get message(): string {
    if (this.isExpired) {
      return 'Por seguridad, debes cambiar tu contraseña para continuar.';
    }
    return this.daysRemaining === 1
      ? 'Queda 1 día para que tu contraseña expire. Te recomendamos cambiarla ahora.'
      : `Quedan ${this.daysRemaining} días para que tu contraseña expire. Te recomendamos cambiarla ahora.`;
  }

  onChangePassword(): void {
    this.changePassword.emit();
  }

  onSkip(): void {
    this.skip.emit();
  }
}
